
/**
 * This module is for SBL only
 */

const state = () => ({
  /**
   * Dialog visibility.
   * @type Boolean
   */
  show: false,

  /**
   * @type String
   */
  url: 'https://community.revo.works/user_bbva/new',

  /**
   * @type String
   */
  qs: '',

  /**
   * @type String
   */
  price: '12,00',
})

const getters = {
  href: state => `${state.url}?${state.qs}`,
}

const mutations = {
  qs (state, v) {
    state.qs = v
  },
  show (state) {
    state.show = true
  },
  hide (state) {
    state.show = false
  },
}

const actions = {
  init ({ commit }, params) {
    commit('qs', new URLSearchParams(params).toString())
  },
  open ({ commit }) {
    commit('show')
  },
  close ({ commit }) {
    commit('hide')
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
